import { render, staticRenderFns } from "./ItemDL_Item_PackagingList_List.vue?vue&type=template&id=5abdf3cf"
import script from "./ItemDL_Item_PackagingList_List.vue?vue&type=script&lang=js"
export * from "./ItemDL_Item_PackagingList_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports